import styled from "styled-components"

export const pBtn = styled.button`
  border-radius: 40px; 
  height: 40px;
  padding: 0px 20px;
  border: none;
  width: fit-content;
  outline: none;
  display: flex;
  font-size: 13px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer; 
  font-family: 'Roboto', sans-serif;
  color: var(--dFontColor);
  transition: all 0.3s ease-in-out;

  @media (max-width: 768px) {
    gap: 7px;
    padding: 0px 10px;
    font-size: 11px;
    height: 36px;
  }

`;

export const pBtnSmall = styled.button`
  border-radius: 30px;  
  height: 30px;
  border: none;
  width: fit-content;
  outline: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0px 15px;
  cursor: pointer;
  font-family: 'Roboto', sans-serif; 
  color: var(--dFontColor);
  transition: all 0.3s ease-in-out;
  
`;

export const PostTextWrap = styled.div` 
    display: flex;
    flex-direction: column;
    color: var(--lightThemeFontColor);
    width: 100%; 
    align-items: flex-start;
    justify-content: flex-start;
    padding-left: ${props => props.hasImage ? '10px': '0px'};


    @media (max-width: 768px) {
        padding-left: 0px;
        padding-top: ${props => props.hasImage ? '10px': '0px'};
    }
`

export const PostSubText = styled.div`
    display: flex;
    margin-top: 5px; 
`

export const SeeMoreBtn = styled.button`
    color: var(--lightThemeFontColor);
    outline: none;
    border: none;
    background-color: transparent;
    font-size: 15px;
    cursor: pointer;
    &:hover{
        text-decoration: underline;
    }
`
export const SeeMore = styled.div`

    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end; 
`




export const MobilePageTitle = styled.h1`
    display: none;

    @media (max-width: 768px) {

        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: fit-content;
        color: var(--lightThemeFontColor);
        font-size: 14px;
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        /* margin-top: 15px; */
        /* margin-bottom: 15px; */
    }
`

export const NoItemsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-top: 20px;
    font-size: 20px;
    color: #ccc;

    svg{
        font-size: 50px;
        color: #ccc;
        margin-top: 20px;
        margin-bottom: 10px;
    }

`

export const ConfirmModalContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 30px;
    padding-top: 40px;
    color:  var(--dFontColor);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    width: 600px;
`

export const ConfirmModalTitle = styled.h2`
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 400;
    text-align: center;
`

export const ConfirmBtnsWrap = styled.div`
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    gap: 20px;
`

export const ConfirmBtn = styled(pBtn)`
    background-color: var(--themeColor);
    color: white;

`
export const CancelBtn = styled(pBtn)`
    background-color: transparent;
    color: var(--themeColor);   
    border: 2px solid white;
    &:hover{
        background-color: white;
        color: var(--themeColor);
    }
`